import { applyThemeFromBranding } from '@core/services/theme';
import { Auth } from '@core/auth';

import { setFavicon } from '@utils/dom';

const loadBranding = async (to, from, next) => {
    const auth = Auth();

    if (!auth.has_branding) {
        await auth.setBranding();
    }

    applyThemeFromBranding(auth.branding().colours);
    setFavicon(auth.branding().image('favicon'));

    next();
};

export default loadBranding;
